"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (password) {
  return password ? /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\s!"#\$%&'\(\)\*\+,\-\.\/:;<>\?@\[\\\]\^_`{|}~])(?=.{8,})/.test(password) : true;
};